import { useRecoilState } from "recoil";
import {
  JoinPolicyModalAtom,
  PasswordInitModalAtom,
  ResumeSubscriptionModalAtom,
} from "src/atoms";

export const useModal = () => {
  const [joinPolicyModalState, setJoinPolicyModalState] =
    useRecoilState(JoinPolicyModalAtom);
  const [isOpenPasswordInitModal, setPasswordInitModal] = useRecoilState(
    PasswordInitModalAtom
  );
  // 구독 재개하기 모달
  const [isResumeSubscription, setResumeSubscription] = useRecoilState(
    ResumeSubscriptionModalAtom
  );
  const openTermsService = () => {
    setJoinPolicyModalState((prev) => ({
      ...prev,
      showPolicy: true,
      tabTarget: "tab1",
    }));
  };
  const openPrivatePolicy = () => {
    setJoinPolicyModalState((prev) => ({
      ...prev,
      showPolicy: true,
      tabTarget: "tab2",
    }));
  };
  const openPaidTermsService = () => {
    setJoinPolicyModalState((prev) => ({
      ...prev,
      showPolicy: true,
      tabTarget: "tab3",
    }));
  };
  const hideModal = () => {
    setJoinPolicyModalState((prev) => ({ ...prev, showPolicy: false }));
  };
  return {
    joinPolicyModalState,
    setJoinPolicyModalState,
    isOpenPasswordInitModal,
    setPasswordInitModal,
    openTermsService, // 이용약관
    openPrivatePolicy, // 개인정보 처리방침
    openPaidTermsService, // 유료 이용약관
    // 구독 재개하기
    isResumeSubscription,
    setResumeSubscription,
    hideModal,
  };
};
